module.exports = __webpack_public_path__ + "images/580dda9a27b57ce11b18d43a0b7eb55c.png";